import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Box, Container, Flex, Spinner } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import Sidebar from 'Components/employersSide/Sidebar';

import { JobForm } from 'jobs/job-form';

import { useRootStore } from 'core/hooks/use-root-store';
import './edit-job.scss';
import { useEditJob } from './edit-job.provider';
import { NoPlanDialog } from 'employer/feature-create-job/no-plan-dialog';

export function EditJobView() {
   const navigate = useNavigate();
   const jobManager = useEditJob();
   const rootStore = useRootStore();
   const { slug } = useParams();
   const [ready, setReady] = React.useState(false);

   React.useEffect(() => {
      if (!slug) {
         return;
      }
      jobManager.loadJob(
         { slugId: slug },
         {
            onPlanError: (error) => {
               rootStore.globalDialog.open(<NoPlanDialog message={error} />, {
                  minWidth: '450px',
                  maxWidth: '450px',
               });
               navigate('/plans/purchase');
            },
            onSuccess: () => {
               setReady(true);
            },
         }
      );
   }, [jobManager, slug]);

   return (
      <>
         <Container px="5" mb="6" mt="3%">
            <Flex width="100%" direction={{ initial: 'column', lg: 'row' }}>
               <Box>
                  <Sidebar />
               </Box>
               <Flex className="job-edit__content" width="100%">
                  {ready ? (
                     <JobForm
                        heading="Редагувати вакансію"
                        jobManager={jobManager}
                        onJobCreate={(res) => {
                           if (res.status === 403) {
                              toast.error(res.message);
                           }

                           if (res.status === 500) {
                              toast.error(res.message);
                           }

                           if (res.status === 200) {
                              toast.success('Вакансію оновлено успішно');
                              navigate('/user/managejob');
                           }
                        }}
                        onCreateError={(error) => {
                           console.error('Feature edit job error');
                           if (error.status === 400) {
                              navigate('/');
                           }
                        }}
                     />
                  ) : (
                     <Flex className="loader-overlay">
                        <Spinner size="3" />
                     </Flex>
                  )}
               </Flex>
            </Flex>
         </Container>
      </>
   );
}

export const EditJob = observer(EditJobView);
